import React from "react";
import { Row, Col, Spinner, Form, InputGroup, Button } from "react-bootstrap";
import {
  FaUser,
  FaEnvelope,
  FaIdCard,
  FaSync,
  FaFileExcel,
} from "react-icons/fa";
import UserCard from "../Robust Components/UserCard";

const UsersTab = ({
  users,
  loading,
  error,
  filters,
  filteredUsers,
  isRefreshing,
  handleFilterChange,
  handleUserClick,
  handleRefresh,
  exportUsersToExcel,
}) => {
  return (
    <>
      <div className="pane-header">
        <div className="d-flex justify-content-start align-items-center">
          <div style={{ marginLeft: "10px" }}>
            <h2 className="pane-title">ניהול משתמשים</h2>
            <p className="pane-subtitle">צפייה ועריכה של משתמשי המערכת</p>
          </div>
          <div className="d-flex gap-2">
            <Button
              variant="outline-success"
              onClick={exportUsersToExcel}
              className="export-button"
            >
              <FaFileExcel className="me-2" />
              צור אקסל לקוחות
            </Button>
            <Button
              variant="outline-primary"
              onClick={handleRefresh}
              disabled={isRefreshing || (loading && users.length === 0)}
              className="refresh-button"
            >
              {isRefreshing || (loading && users.length === 0) ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  {isRefreshing ? "מרענן..." : "טוען..."}
                </>
              ) : (
                <>
                  <FaSync className="me-2" />
                  רענון
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
      <div className="filters-container">
        <Row>
          <Col md={4}>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <FaUser />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="חיפוש לפי שם"
                name="userName"
                value={filters.userName}
                onChange={handleFilterChange}
                className="filter-input"
              />
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <FaEnvelope />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="חיפוש לפי אימייל"
                name="userEmail"
                value={filters.userEmail}
                onChange={handleFilterChange}
                className="filter-input"
              />
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup className="mb-3">
              <InputGroup.Text>
                <FaIdCard />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="חיפוש לפי מזהה משתמש"
                name="userId"
                value={filters.userId}
                onChange={handleFilterChange}
                className="filter-input"
              />
            </InputGroup>
          </Col>
        </Row>
      </div>
      <div className="users-container">
        {loading && users.length === 0 ? (
          <div className="text-center p-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">טוען...</span>
            </Spinner>
          </div>
        ) : error ? (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        ) : (
          <>
            <div className="users-count">
              נמצאו {filteredUsers.length} משתמשים
            </div>
            <Row>
              {filteredUsers.map((user) => (
                <Col
                  key={user.id}
                  xs={12}
                  md={6}
                  lg={4}
                  xl={3}
                  onClick={() => handleUserClick(user)}
                >
                  <UserCard user={user} />
                </Col>
              ))}
            </Row>
          </>
        )}
      </div>
    </>
  );
};

export default UsersTab;
